<template>
  <div class="upsert-preorder">
    <KTCodePreview :title="pageTitle">
      <template v-slot:preview>
        <div v-if="loading" class="text-center py-5">
          <b-spinner></b-spinner>
          <p class="mt-2">Đang tải...</p>
        </div>

        <div v-else>
          <ValidationObserver ref="observer">
            <b-form @submit.prevent="onSubmit">
              <div class="mb-3">
                <b-row>
                  <b-col md="3">
                    <div class="section-title mb-4">Đơn đặt trước</div>

                    <b-form-group label="Cửa hàng" label-for="storeId">
                      <Treeselect
                        id="storeId"
                        :value="preorderForm.storeId"
                        :options="storeOptionsForTree"
                        :multiple="false"
                        :placeholder="'Chọn cửa hàng'"
                        :clearable="false"
                        :disabled="mode === MODE.VIEW"
                        retryText="Thử lại..."
                        searchPromptText="Nhập để tìm kiếm..."
                        noResultsText="Không có kết quả"
                        openDirection="bottom"
                        @input="emitUpdate('storeId', $event)"
                      />
                    </b-form-group>

                    <b-form-group label="Loại đơn" label-for="type">
                      <b-form-select
                        id="type"
                        v-model="preorderForm.type"
                        :options="typeOptions"
                        value-field="value"
                        text-field="text"
                        @change="emitUpdate('type', preorderForm.type)"
                      >
                        <template #first>
                          <b-form-select-option :value="null"
                            >-- Chọn loại --</b-form-select-option
                          >
                        </template>
                      </b-form-select>
                    </b-form-group>

                    <b-form-group label="Trạng thái" label-for="status">
                      <Treeselect
                        id="status"
                        :value="preorderForm.status"
                        :options="statusOptionsForTree"
                        :multiple="false"
                        :placeholder="'Chọn trạng thái'"
                        :clearable="false"
                        :disabled="mode === MODE.VIEW"
                        retryText="Thử lại..."
                        searchPromptText="Nhập để tìm kiếm..."
                        noResultsText="Không có kết quả"
                        openDirection="bottom"
                        @input="emitUpdate('status', $event)"
                      />
                    </b-form-group>

                    <b-form-group label="Ghi chú" label-for="note">
                      <b-form-textarea
                        id="note"
                        v-model="preorderForm.note"
                        rows="6"
                        :disabled="mode === MODE.VIEW"
                        @input="emitUpdate('note', preorderForm.note)"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <CustomerSection
                      :form="preorderForm"
                      :mode="mode"
                      :on-submiting="submitting"
                      @update-field="updateField"
                    />
                  </b-col>

                  <!-- <b-col md="3">
                    <div class="section-title mb-4">Thông tin thanh toán</div>

                    <b-form-group label="Trả trước" label-for="depositAmount">
                      <b-form-input
                        id="depositAmount"
                        type="number"
                        v-model.number="preorderForm.depositAmount"
                        :disabled="mode === MODE.VIEW"
                        @input="
                          emitUpdate(
                            'depositAmount',
                            preorderForm.depositAmount,
                          )
                        "
                      />
                    </b-form-group>
                    <b-form-group
                      v-if="hasDeposit"
                      label="Tài khoản nhận cọc"
                      label-for="cashAccountId"
                    >
                      <AutoSuggest
                        :model="preorderForm.cashAccountName"
                        :suggestions="cashAccountSuggestions"
                        placeholder="Chọn tài khoản tiền mặt"
                        suggestion-name="label"
                        :disabled="mode === MODE.VIEW"
                        @update:model="preorderForm.cashAccountName = $event"
                        @change="onCashAccInputChange"
                        @select="onCashAccSelected"
                      >
                        <div slot="custom" slot-scope="{ suggestion }">
                          {{ suggestion.item.label }}
                          <span
                            v-if="suggestion.item.code"
                            class="text-muted small"
                          >
                            ({{ suggestion.item.code }})
                          </span>
                        </div>
                      </AutoSuggest>
                    </b-form-group>
                  </b-col> -->

                  <b-col md="3">
                    <div class="section-title mb-4">Thông tin khác</div>

                    <b-form-group label="Nhân viên tạo">
                      <b-form-input plaintext :value="staffDisplayName" />
                    </b-form-group>

                    <PreorderHistorySection
                      v-if="mode !== MODE.ADD && preorderForm.id"
                      :preorder-id="preorderForm.id"
                    />
                  </b-col>
                </b-row>
              </div>

              <ProductsSection
                :form="preorderForm"
                :mode="mode"
                @update-field="updateField"
                @uploading-change="imageUploading = $event"
              />

              <div
                class="d-flex mt-4 align-items-center"
                v-if="mode !== MODE.VIEW"
              >
                <b-button variant="secondary" class="mr-2" @click="goBack">
                  Hủy
                </b-button>
                <b-button
                  variant="primary"
                  type="submit"
                  :disabled="submitting || imageUploading"
                >
                  <b-spinner v-if="submitting" small class="mr-2"></b-spinner>
                  {{ mode === MODE.ADD ? 'Lưu' : 'Cập nhật' }}
                </b-button>
                <b-button
                  v-if="showConvertButton"
                  variant="outline-success"
                  class="ml-2"
                  :disabled="convertLoading"
                  @click="openConvertModal"
                >
                  Chuyển đơn hàng
                </b-button>
              </div>
              <div
                class="d-flex mt-4 align-items-center"
                v-else-if="showConvertButton"
              >
                <b-button
                  variant="outline-success"
                  @click="openConvertModal"
                  :disabled="convertLoading"
                >
                  Chuyển đơn hàng
                </b-button>
              </div>
            </b-form>
          </ValidationObserver>
        </div>
      </template>
    </KTCodePreview>

    <ConvertPreorderModal
      :show="showConvertModal"
      :preorder="preorderForm"
      :convert-loading="convertLoading"
      @close="closeConvertModal"
      @confirm="handleConvert"
    />
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import KTCodePreview from '@/view/content/CodePreview.vue';
import { ValidationObserver } from 'vee-validate';
import PreorderService from '@/core/api/preorder/preorder.service';
import PreorderProgramService from '@/core/api/preorder/preorder-program.service';
import ApiService from '@/core/services/api.service';
import { makeToastFaile, makeToastSuccess } from '@/utils/common';
import { permissionMixin } from '@/view/mixins/permission.mixins';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { PreOrderModel } from '@/core/models/PreOrder.model';
import * as ENUM from '@/utils/enum';
import * as ENUM_NAME from '@/utils/enum-name';
import ProductsSection from './components/ProductsSection.vue';
import CustomerSection from './components/CustomerSection.vue';
import ConvertPreorderModal from './components/ConvertPreorderModal.vue';
import PreorderHistorySection from './components/PreorderHistorySection.vue';
import { ACCOUNTANT_TYPE } from '@/utils/enum';

const ROUTE_CONFIGS = {
  'add-preorder': { mode: ENUM.MODE.ADD, title: 'Thêm đơn đặt trước' },
  'edit-preorder': { mode: ENUM.MODE.EDIT, title: 'Cập nhật đơn đặt trước' },
  'view-preorder': { mode: ENUM.MODE.VIEW, title: 'Chi tiết đơn đặt trước' },
};

export default {
  name: 'UpsertPreorder',
  mixins: [permissionMixin],
  components: {
    Treeselect,
    KTCodePreview,
    ValidationObserver,
    ProductsSection,
    CustomerSection,
    ConvertPreorderModal,
    PreorderHistorySection,
  },
  props: {
    id: { type: [String, Number], default: null },
  },
  data() {
    return {
      MODE: ENUM.MODE,
      loading: false,
      submitting: false,
      imageUploading: false,
      preorderForm: new PreOrderModel(),
      storeOptions: [],
      programOptions: [],
      statusOptions: this.getOptions(
        ENUM.PREORDER_STATUS,
        ENUM_NAME.PREORDER_STATUS_NAME,
      ),
      typeOptions: this.getOptions(
        ENUM.PREORDER_TYPE,
        ENUM_NAME.PREORDER_TYPE_NAME,
      ),
      showConvertModal: false,
      convertLoading: false,
      listCashAccSearch: [],
    };
  },
  computed: {
    hasDeposit() {
      return Number(this.preorderForm.depositAmount ?? 0) > 0;
    },
    cashAccountSuggestions() {
      return (this.listCashAccSearch || []).map((a) => ({
        id: a.id,
        name: a.name,
        label: a.name || a.code || '',
        code: a.code,
      }));
    },
    mode() {
      return ROUTE_CONFIGS[this.$route.name]?.mode ?? ENUM.MODE.ADD;
    },
    pageTitle() {
      return ROUTE_CONFIGS[this.$route.name]?.title ?? 'Đơn đặt trước';
    },
    staffDisplayName() {
      const u = this.loadCurrentUser();
      return u.fullName || '-';
    },
    storeOptionsForTree() {
      return (this.storeOptions || []).map((s) => ({
        id: s.id,
        label: s.name || s.shortName || s.id,
      }));
    },
    statusOptionsForTree() {
      return (this.statusOptions || []).map((s) => ({
        id: s.value,
        label: s.text,
      }));
    },
    programOptionsForTree() {
      return (this.programOptions || []).map((p) => ({
        id: p.id,
        label: p.name || '',
      }));
    },
    canConvert() {
      return this.hasPermission(ENUM.PERMISSIONS.PRE_ORDER_CONVERT);
    },
    showConvertButton() {
      return (
        this.mode === ENUM.MODE.EDIT &&
        this.preorderForm.id &&
        this.preorderForm.targetProductId &&
        !this.preorderForm.convertedOrderId &&
        this.canConvert
      );
    },
  },
  watch: {
    'preorderForm.storeId'(val) {
      if (val && this.hasDeposit) this.loadCashAccountsForDeposit();
    },
  },
  async mounted() {
    this.setBreadCrumbs();
    await this.loadPrograms();
    await this.loadStores();
    if (this.mode !== ENUM.MODE.ADD && this.$route.params.id) {
      await this.loadPreorder();
    } else {
      const user = this.loadCurrentUser();
      this.preorderForm.storeId =
        user.storeId || (this.storeOptions[0] && this.storeOptions[0].id);
      this.preorderForm.type = ENUM.PREORDER_TYPE.PreOrder;
      this.preorderForm.status = ENUM.PREORDER_STATUS.New;
    }
  },
  methods: {
    setBreadCrumbs() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: 'Đơn đặt trước', route: '/preorder' },
        { title: this.pageTitle, active: true },
      ]);
    },

    getOptions(enumValues, enumNames) {
      if (!enumValues || !enumNames) return [];
      return Object.values(enumValues).map((val) => ({
        value: val,
        text: enumNames[val] || val,
      }));
    },

    async loadStores() {
      try {
        const { data } = await ApiService.get('stores/get-by-user');
        const stores = data?.data?.stores || data?.stores || [];
        this.storeOptions = stores.map((s) => ({
          id: s.id,
          name: s.name || s.shortName || s.id,
        }));
      } catch (e) {
        console.error('Load stores failed', e);
      }
    },

    async loadPrograms() {
      try {
        const { data } = await PreorderProgramService.list();
        const list = data?.data || data || [];
        this.programOptions = list.map((p) => ({ id: p.id, name: p.name }));
      } catch (e) {
        console.error('Load programs failed', e);
      }
    },

    async loadPreorder() {
      const id = this.$route.params.id || this.id;
      if (!id) return;
      this.loading = true;
      try {
        const { data } = await PreorderService.getById(id);
        const raw = data.data || data;
        this.preorderForm = PreOrderModel.fromJson(raw);
        if (this.hasDeposit) await this.loadCashAccountsForDeposit();
      } catch (e) {
        makeToastFaile('Không thể tải đơn đặt trước');
        this.$router.push({ name: 'list-preorder' });
      } finally {
        this.loading = false;
      }
    },

    updateField({ field, value }) {
      this.$set(this.preorderForm, field, value);
    },

    emitUpdate(field, value) {
      this.$set(this.preorderForm, field, value);
    },

    async loadCashAccountsForDeposit() {
      const storeId = this.preorderForm?.storeId || undefined;
      try {
        const params = { type: ACCOUNTANT_TYPE.CASH };
        if (storeId) params.storeId = storeId;
        const res = await ApiService.query('accountants/getByType', { params });
        const list = res?.data?.data ?? res?.data ?? [];
        const items = Array.isArray(list) ? list : [];
        this.listCashAccSearch = items.map((item) => ({
          id: item.id,
          name: item.name || item.code || '',
          code: item.code,
        }));
        if (this.preorderForm.cashAccountId && this.listCashAccSearch.length) {
          const found = this.listCashAccSearch.find(
            (a) => a.id === this.preorderForm.cashAccountId,
          );
          this.$set(
            this.preorderForm,
            'cashAccountName',
            found ? found.name || found.code || '' : '',
          );
        }
      } catch (e) {
        console.error('Load cash accounts failed', e);
        this.listCashAccSearch = [];
      }
    },
    onCashAccInputChange(text) {
      this.$set(this.preorderForm, 'cashAccountName', text);
      if (!text) this.$set(this.preorderForm, 'cashAccountId', null);
    },
    onCashAccSelected(option) {
      if (option?.item) {
        this.$set(this.preorderForm, 'cashAccountId', option.item.id);
        this.$set(
          this.preorderForm,
          'cashAccountName',
          option.item.label || option.item.name || '',
        );
      } else {
        this.$set(this.preorderForm, 'cashAccountId', null);
        this.$set(this.preorderForm, 'cashAccountName', '');
      }
    },

    goBack() {
      this.$router.push({ name: 'list-preorder' });
    },

    openConvertModal() {
      this.showConvertModal = true;
    },
    closeConvertModal() {
      this.showConvertModal = false;
    },
    async handleConvert(payload) {
      if (!this.preorderForm.id) return;
      this.convertLoading = true;
      try {
        const res = await PreorderService.convert(
          this.preorderForm.id,
          payload,
        );
        const order = res?.data?.data || res?.data || res;
        const orderId = order?.id ?? order;
        makeToastSuccess('Chuyển đơn hàng thành công');
        this.closeConvertModal();
        await this.loadPreorder();

        if (orderId) {
          this.$router.push({ name: 'edit-order', params: { id: orderId } });
        }
      } catch (e) {
        makeToastFaile(e?.response?.data?.message || 'Chuyển đơn thất bại');
      } finally {
        this.convertLoading = false;
      }
    },

    async onSubmit() {
      const valid = await this.$refs.observer.validate();
      if (!valid) {
        makeToastFaile('Vui lòng nhập đủ thông tin bắt buộc');
        return;
      }
      const phone = (this.preorderForm.customerPhone || '').trim();
      const name = (this.preorderForm.customerName || '').trim();
      if (phone.length < 8 || phone.length > 15) {
        makeToastFaile('Vui lòng nhập số điện thoại hợp lệ (8-15 ký tự)');
        return;
      }
      if (!name) {
        makeToastFaile('Vui lòng nhập họ tên khách hàng');
        return;
      }
      if (
        this.preorderForm.tradeinProductName &&
        !this.preorderForm.tradeinChassisNumber
      ) {
        makeToastFaile('Khi có thông tin xe thu cũ, Số khung là bắt buộc');
        return;
      }

      this.submitting = true;
      try {
        const payload = {
          ...this.preorderForm,
          storeId: this.preorderForm.storeId,
          customerPhone: this.preorderForm.customerPhone,
          customerName: this.preorderForm.customerName,
          customerAppellation: this.preorderForm.customerAppellation ?? null,
          customerEmail: this.preorderForm.customerEmail || null,
          customerAddress: this.preorderForm.customerAddress || null,
          customerWardId: this.preorderForm.customerWardId ?? null,
          customerDetailAddress:
            this.preorderForm.customerDetailAddress || null,
          customerDateOfBirth: this.preorderForm.customerDateOfBirth || null,
          tradeinProductName: this.preorderForm.tradeinProductName || null,
          tradeinChassisNumber: this.preorderForm.tradeinChassisNumber || null,
          tradeinEngineNumber: this.preorderForm.tradeinEngineNumber || null,
          tradeinAttributes: this.preorderForm.tradeinAttributes || null,
          tradeinEstimationPrice:
            this.preorderForm.tradeinEstimationPrice ?? null,
          tradeinFinalPrice: this.preorderForm.tradeinFinalPrice ?? null,
          targetProductId: this.preorderForm.targetProductId || null,
          targetProductName: this.preorderForm.targetProductName || null,
          targetQuotedPrice: this.preorderForm.targetQuotedPrice ?? null,
          depositAmount: this.preorderForm.depositAmount ?? 0,
          cashAccountId: this.preorderForm.cashAccountId ?? null,
          note: this.preorderForm.note || null,
          status: this.preorderForm.status ?? ENUM.PREORDER_STATUS.New,
          type: this.preorderForm.type ?? ENUM.PREORDER_TYPE.PreOrder,
          preorderProgramId: this.preorderForm.preorderProgramId ?? null,
        };

        if (this.mode === ENUM.MODE.ADD) {
          await PreorderService.create(payload);
          makeToastSuccess('Thêm đơn đặt trước thành công');
        } else {
          await PreorderService.update(this.preorderForm.id, payload);
          makeToastSuccess('Cập nhật đơn đặt trước thành công');
        }
        this.$router.push({ name: 'list-preorder' });
      } catch (e) {
        makeToastFaile(
          e?.response?.data?.message?.join(', ') ||
            (this.mode === ENUM.MODE.ADD
              ? 'Thêm thất bại'
              : 'Cập nhật thất bại'),
        );
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.section-title {
  font-weight: 600;
  font-size: 1.05rem;
}
</style>
